var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row m-0" }, [
    _c(
      "div",
      { staticClass: "col-md-12 col-lg-12 col-sm-12 p-0" },
      [
        _vm.servicesList.length
          ? _c("div", { staticClass: "p-0 col-xs-12 first_table" }, [
              _c("table", { staticClass: "table activity-tracker-table" }, [
                _c("thead", [
                  _c(
                    "tr",
                    [
                      _c("th", { staticClass: "filter-th wd-65 sticky" }),
                      _vm._l(_vm.tableHeaders, function (header) {
                        return [
                          header !== "plan_id"
                            ? _c(
                                "th",
                                {
                                  key: header,
                                  class: { "w-35": header === "name" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.sortBy(header)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm._f("capitalize")(header)) +
                                      " "
                                  ),
                                  _c("span", {
                                    staticClass: "arrow",
                                    class:
                                      _vm.sortOrders[header] > 0
                                        ? "asc"
                                        : "dsc",
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ]
                      }),
                    ],
                    2
                  ),
                ]),
                _c(
                  "tbody",
                  _vm._l(_vm.servicesList, function (service, index) {
                    return _c("tr", { key: service.id }, [
                      _c("td", { staticClass: "menu-td sticky" }, [
                        !service.upgraded
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "dropdown dropdown-export export-activity-menu text-center",
                                attrs: { id: "trackerActionDots" + index },
                              },
                              [
                                _vm._m(0, true),
                                _c(
                                  "ul",
                                  {
                                    staticClass:
                                      "activitytrackermenu dropdown-menu export-menu",
                                    attrs: { disabled: service.upgraded },
                                  },
                                  [
                                    _c(
                                      "li",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.displayProdClassUpgradeOptions(
                                              service
                                            )
                                          },
                                        },
                                      },
                                      [_vm._m(1, true)]
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _c("td", [_vm._v(" " + _vm._s(service.report) + " ")]),
                      _c("td", [_vm._v(" " + _vm._s(service.market) + " ")]),
                      _c("td", [
                        _vm._v(" " + _vm._s(service.classification) + " "),
                      ]),
                      _c("td", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("dateFormatter")(service.date_created)
                            ) +
                            " "
                        ),
                      ]),
                      _c("td", [
                        service.upgraded
                          ? _c("img", {
                              staticClass: "image-size",
                              attrs: {
                                src: "/static/images/icons/check.svg",
                                alt: "check-icon",
                              },
                            })
                          : _vm._e(),
                      ]),
                    ])
                  }),
                  0
                ),
              ]),
            ])
          : _c("div", { staticClass: "norecords_wrapper p-20" }, [
              _c("div", { staticClass: "no-records-found" }, [
                _vm._v("No Records Found"),
              ]),
            ]),
        _c("product-classification-report-upgrade-modal", {
          attrs: { headerId: _vm.rationaleRepId },
        }),
        _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: { "margin-top": "1px" },
        attrs: { "data-toggle": "dropdown" },
      },
      [
        _c("span", { staticClass: "dropdown-toggle" }, [
          _c("i", { staticClass: "fa fa-ellipsis-v menu-dots" }),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { staticClass: "text-color-blue menu-dots-links" }, [
      _c("span", [_vm._v("Upgrade To Expert Review")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }